
import { defineComponent } from "vue"
import type { PhotoGroup } from "@/types/api/photo"

export default defineComponent({
  props: {
    group: {
      type: Object as VuePropType<PhotoGroup>,
      required: true,
    },
  },

  computed: {
    coverUrl (): string {
      return this.group.cover?.url || "/img/contact-form-bg.webp"
    },

    date (): string {
      const { date } = this.group
      if (!date) return ""
      return new Intl.DateTimeFormat(this.$i18n.locale, {
        dateStyle: "short",
        timeZone: "UTC",
      }).format(new Date(date))
    },
  },
})
